import { render } from "./ReSubscribe.vue?vue&type=template&id=6a602039&scoped=true"
import script from "./ReSubscribe.vue?vue&type=script&lang=js"
export * from "./ReSubscribe.vue?vue&type=script&lang=js"

import "./ReSubscribe.vue?vue&type=style&index=0&id=6a602039&lang=less&scoped=true"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a602039"]])

export default __exports__